// Keep all these in the order they should be shown
export enum HexColor {
    green = '#84cc16',
    cyan = '#06b6d4',
    amber = '#ef4444',
    fuchsia = '#d946ef',
    white = '#FFF'
}